new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: false,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('#faixa-comunicado').then(element => {
        $('#faixa-comunicado').slick({
            arrows: false,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            delay: 2000,
            speed: 700,

            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });

        function updateSectionMargin() {
            const banner = document.querySelector(".home__banner");
            const section = document.getElementById("section-1");

            if (banner && section) {
                const bannerHeight = banner.offsetHeight;
                const marginTop = bannerHeight * 0.6;
                section.style.marginTop = `${marginTop}px`;
            }
        }

        updateSectionMargin()
        window.addEventListener("resize", updateSectionMargin);

        function loadVerifiedSeal(onLoad, onError) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'ra-embed-verified-seal';
            script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
            
            script.setAttribute('data-id', 'cEdsU3MtX2cxY3oxdjBaYzpjcGFwb24=');
            script.setAttribute('data-target', 'ra-verified-seal');
            script.setAttribute('data-model', 'horizontal_3');

            if (onLoad) script.onload = onLoad;
            if (onError) script.onerror = onError;

            document.head.appendChild(script);
        }

        // Uso
        loadVerifiedSeal(
            () => console.log('Script carregado'),
            () => console.error('Falha ao carregar o script')
        );

    });

    waitForElementToExist('.product_list').then(element => {
        $('.product_list').slick({
            arrows: false,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        let rotationVitrine = document.querySelector('.rotation-vitrine');
        if (rotationVitrine) {
            let rotationNames = rotationVitrine.querySelectorAll('.categories .categories__name');
            let initVitrine = rotationVitrine.querySelectorAll('.rotation-vitrine__products .item');
            initVitrine = Array.from(initVitrine);

            if (rotationVitrine && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    $('#js-rotation-vitrine6, #js-rotation-vitrine5, #js-rotation-vitrine4, #js-rotation-vitrine3, #js-rotation-vitrine2, #js-rotation-vitrine').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        Blazy({
                            selector: '.lazy-img',
                            successClass: 'loaded-img',
                            success: function (element) {
                                setTimeout(function () {
                                    var parent = element.previousSibling;
                                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                }, 100);
                            }
                        });
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }
        }

        $('#js-rotation-vitrine, #js-rotation-vitrine2, #js-rotation-vitrine3, #js-rotation-vitrine4, #js-rotation-vitrine5, #js-rotation-vitrine6').slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        })
    });

    waitForElementToExist('.product_list-2').then(element => {
        $('.product_list-2').slick({
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.product_list-3').then(element => {
        $('.product_list-3').slick({
            appendDots: $(".slick-m-dots-3"),
            prevArrow: $(".slick-m-prev-3"),
            nextArrow: $(".slick-m-next-3"),
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.product_list-4').then(element => {
        $('.product_list-4').slick({
            appendDots: $(".slick-m-dots-4"),
            prevArrow: $(".slick-m-prev-4"),
            nextArrow: $(".slick-m-next-4"),
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.product_list-5').then(element => {
        $('.product_list-5').slick({
            appendDots: $(".slick-m-dots-5"),
            prevArrow: $(".slick-m-prev-5"),
            nextArrow: $(".slick-m-next-5"),
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.slick-infos').then(element => {
        $('#widget-infos').slick({
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $(document).ready(function () {
            var $slider = $('#widget-infos');
            var $progressBar = $('.widget-infos__progress');

            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

                $progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
            });
        });
    });

    $('.product-ratings-list').slick({
        appendDots: $(".slick-m-dots-6"),
        prevArrow: $(".slick-m-prev-6"),
        nextArrow: $(".slick-m-next-6"),
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });
})
